import chevronUp from '@img/icons/chevron-up.svg?raw';
import chevronRight from '@img/icons/chevron-right.svg?raw';
import chevronDown from '@img/icons/chevron-down.svg?raw';
import chevronLeft from '@img/icons/chevron-left.svg?raw';
import search from '@img/icons/search.svg?raw';

const Theme = new class {
    constructor() {
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight,
        };

        this.scroll = {
            lastScrollTop: 0,
            delta: 5,
        };

        this.transitions = {
            speed: 250,
        };

        this.svgs = {
            chevronUp: chevronUp,
            chevronRight: chevronRight,
            chevronDown: chevronDown,
            chevronLeft: chevronLeft,
            search: search,
        };

        this.isTouchDevice = ('ontouchstart' in window) || (navigator.msMaxTouchPoints || navigator.maxTouchPoints) > 2;

        this.sliders = {};

        this.callables = [];
    }

    setCallables(callables) {
        this.callables = callables;
    }

    onResize() {
        window.addEventListener('resize', () => {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        });
    }

    init() {
        this.onResize();

        if (this.callables.length > 0) {
            this.callables.forEach(callable => callable());
        }

        window.dispatchEvent(new CustomEvent('landedHouses/loaded'));
    }
}

export default Theme;
